// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"de378280","147":"f62c9027","265":"8803cfa7","295":"8d4ebe45","574":"6c85020d","615":"1c31c71b","818":"e222e61c","899":"ea1e3bd7","900":"815301c4"}[chunkId] + ".chunk.js";
};